import { render, staticRenderFns } from "./ElInpuInteger.vue?vue&type=template&id=2a31b69e&scoped=true"
import script from "./ElInpuInteger.vue?vue&type=script&lang=js"
export * from "./ElInpuInteger.vue?vue&type=script&lang=js"
import style0 from "./ElInpuInteger.vue?vue&type=style&index=0&id=2a31b69e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31b69e",
  null
  
)

export default component.exports